import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Pain points" className="bg-charcoal" data-id="element-112" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 py-14 sm:py-20" style={{
      paddingTop: "20px",
      paddingBottom: "26px"
    }} data-id="element-113" data-mp="26yxtcue58i1y">
        <h2 className="text-center font-display text-[28px] font-extrabold tracking-tight text-ice sm:text-4xl" data-id="element-114" data-mp="2bwhbw6hvjgzp">
          Does this sound like you?
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-base leading-relaxed text-steel" data-id="element-115" data-mp="21zctmhr5g5o6">
          You love the fire service, but after a demanding call or a long shift, there may still be
          reports to complete, training sessions to organize, equipment records to update, and
          administrative tasks waiting for your attention.
        </p>
        <p className="mx-auto mt-5 max-w-2xl text-center font-display text-lg font-bold text-ice sm:text-xl" data-id="element-116" data-mp="3iee5dzeu4lu7">
          It’s not a lack of dedication. It’s a lack of a <span className="text-crimson" data-id="element-117" data-mp="1yzvidgbxglte">practical AI workflow</span>.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-118" data-mp="1u1txcpuxycfa">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-4 rounded-2xl border border-white/[0.07] bg-obsidian p-5 sm:p-6" data-id="element-119" data-mp="27sz389owk0y2" data-mpi={i}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-crimson/10 text-crimson ring-1 ring-crimson/25" aria-hidden="true" data-id="element-120" data-mp="1b4subaky6mdz">
                <p.icon className="h-5 w-5" data-id="element-121" data-mp="1k2mnicnf0zwx" />
              </span>
              <div data-id="element-122" data-mp="30he7q2aer0v5">
                <h3 className="font-display text-base font-bold text-ice" data-id="element-123" data-mp="30gmjjcj545ew">{p.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-steel" data-id="element-124" data-mp="2vjclx9llknfz">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-xl font-extrabold leading-snug text-ice sm:text-2xl" data-id="element-125" data-mp="1t4vjyivz2mpq">
          ✨ If you answered YES, SIGMA SMART™ has a practical solution to help you get started.
        </p>
      </div>
    </section>;
}